import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from './ui/dialog';
import { ProfilePhoto } from './ProfilePhoto';
import { Camera } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';

export function ProfilePhotoEditor({ currentPhotoUrl, name, onUpdate }) {
  const [open, setOpen] = useState(false);
  const [photoUrl, setPhotoUrl] = useState(currentPhotoUrl || '');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      const response = await api.put('/auth/photo', { photo_url: photoUrl });
      onUpdate?.(response.data.photo_url);
      toast.success('¡Foto actualizada!');
      setOpen(false);
    } catch (error) {
      toast.error('Error al guardar foto');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button className="relative group" data-testid="photo-edit-btn">
          <ProfilePhoto photoUrl={currentPhotoUrl} name={name} size={80} />
          <div className="absolute inset-0 bg-black/50 rounded-full opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
            <Camera className="w-5 h-5 text-white" />
          </div>
        </button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-heading">Cambiar Foto de Perfil</DialogTitle>
        </DialogHeader>
        
        <div className="flex flex-col items-center py-6">
          <ProfilePhoto photoUrl={photoUrl} name={name} size={120} />
          <p className="text-sm text-slate-500 mt-2">Vista previa</p>
        </div>

        <div className="space-y-4">
          <div className="space-y-2">
            <Label>URL de la Imagen</Label>
            <Input
              placeholder="https://ejemplo.com/mi-foto.jpg"
              value={photoUrl}
              onChange={(e) => setPhotoUrl(e.target.value)}
              data-testid="photo-url-input"
            />
            <p className="text-xs text-slate-500">
              Puedes usar servicios como Imgur, Cloudinary o cualquier URL de imagen pública
            </p>
          </div>
        </div>

        <DialogFooter className="mt-4">
          <Button variant="outline" onClick={() => setOpen(false)}>
            Cancelar
          </Button>
          <Button onClick={handleSave} disabled={saving} data-testid="save-photo-btn">
            {saving ? 'Guardando...' : 'Guardar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default ProfilePhotoEditor;
